/**
 * SGKE363A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SupplystopresumptionPointinfomngInfo {

    /**
     * 供給停止再開地点情報管理_更新通番号
     */
    supplystopresumptionPointinfomngUpdatesequencenumber?: string;
    /**
     * 請求お客さま番号
     */
    recptFixNo?: string;
    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * サービス契約番号
     */
    srvCtrNo?: string;
    /**
     * まとめ請求区分コード
     */
    mtmclmDivcd?: string;
    /**
     * メーター番号
     */
    meterNo?: string;
    /**
     * メーター型
     */
    meterKata?: string;
    /**
     * メーター能力
     */
    meterAbility?: number;
    /**
     * メーター識別
     */
    meterDiscrm?: string;
    /**
     * 総合区分
     */
    sougouDiv?: string;
    /**
     * 初期設定作業予定日付
     */
    initialsetupWorkScddt?: string;
    /**
     * 使用場所住所
     */
    empposAddr?: string;
    /**
     * 総合供給先番号
     */
    sougouSupplydestinationNo?: string;
}

